function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import getScopeId from '../utils/get-scope-id';
export default {
  computed: {
    scopedStyleAttrs: function scopedStyleAttrs() {
      var scopeId = getScopeId(this.$parent);
      return scopeId ? _defineProperty({}, scopeId, '') : {};
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/mixins/scoped-style-attrs.js
// module id = 210
// module chunks = 44